import { render, staticRenderFns } from "./AllocationHistoryTable.vue?vue&type=template&id=7ebc6c81&"
import script from "./AllocationHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AllocationHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports